export default __webpack_public_path__ + "static/media/IMG-20241005-WA0013.1225c63b.jpg";